import { createRouter, createWebHistory } from 'vue-router';
import * as store from './../store/store';
import { hasMsalAuthResponseInUrl, isPendingSsoRedirectLogin } from '@/auth/msal';

import Login from './../components/login/Login.vue';
import LoginPassword from './../components/login/LoginPassword.vue';
import usersList from './../components/users/usersList.vue';
import Informing from './../components/users/Informing.vue';
import Users from './../components/users/Users.vue';
import userProfile from './../components/users/userProfile.vue';
import Notices from './../components/users/Notices.vue';
import SetPassword from './../components/users/setPassword.vue';
import FAQGeneral from './../components/users/FAQGeneral.vue';
import FAQSections from './../components/sections/FAQSections.vue';
import FAQWorkPlan from './../components/sections/FAQWorkPlan.vue';
import FAQEvalvation from './../components/evalvation/FAQEvalvation.vue';
import EvalvationDashboard from './../components/evalvation/EvalvationDashboard.vue';
import Sections from './../components/sections/Sections.vue';
import SectionsWorkPlan from './../components/sections/SectionsWorkPlan.vue';
import SectionsList from './../components/sections/SectionsList.vue';
import SectionsDetail from './../components/sections/SectionsDetail.vue';
import SectionsDashboard from './../components/sections/SectionsDashboard.vue';
import SectionsAnalytics from './../components/sections/SectionsAnalytics.vue';
import Evalvation from './../components/evalvation/Evalvation.vue';
import EvalvationProgramList from './../components/evalvation/EvalvationProgramList.vue';
import EvalvationPrograms from './../components/evalvation/EvalvationPrograms.vue';
import QuestionnaireBuild from './../components/evalvation/EvalvationQuestionnaireBuild.vue';
import ProgramDetail from './../components/evalvation/EvalvationProgramDetail.vue';
import EvalvationDepartments from './../components/evalvation/EvalvationDepartments.vue';
import EvalvationDepartmentDetail from './../components/evalvation/EvalvationDepartmentDetail.vue';
import EvalvationDepartmentQuestionnaireBuild from './../components/evalvation/EvalvationDepartmentQuestionnaireBuild.vue';
import EvalvationAnalytics from './../components/evalvation/EvalvationAnalytics.vue';
import EvalvationAI from './../components/evalvation/EvalvationAI.vue';

export const routes = [
  {
    path: '/',
    redirect: () => {
      if (!store.state.user.id) return '/login';
      if (store.state.user.access_sections == 1) return '/podrocja';
      if (store.state.user.access_work_plan == 1) return '/program-dela';
      if (store.state.user.access_evalvation == 1) return '/samoevalvacija/programi';
      return '/obvestila';
    },
  },
  {
    path: '/podrocja',
    component: Sections,
    children: [
      { path: '', redirect: '/podrocja/seznam-podrocij' },
      { path: 'seznam-podrocij', name: 'sectionsList', component: SectionsList },
      { path: 'podrobnosti/:section_id', name: 'sectionsDetail', component: SectionsDetail },
      { path: 'dashboard', name: 'sectionsDashboard', component: SectionsDashboard },
      { path: 'analitika', name: 'sectionsAnalytics', component: SectionsAnalytics },
      { path: 'faq', name: 'FAQSections', component: FAQSections }
    ]
  },
  {
    path: '/program-dela',
    component: SectionsWorkPlan,
    children: [
      { path: '', redirect: '/program-dela/seznam-podrocij' },
      { path: 'seznam-podrocij', name: 'sectionsListWorkPlan', component: SectionsList },
      { path: 'podrobnosti/:section_id', name: 'sectionsDetailWorkPlan', component: SectionsDetail },
      { path: 'dashboard', name: 'sectionsDashboardWorkPlan', component: SectionsDashboard },
      { path: 'faq', name: 'FAQWorkPlan', component: FAQWorkPlan }
    ]
  },
  {
    path: '/samoevalvacija',
    component: Evalvation,
    children: [
      {
        path: '',
        redirect: () =>
          store.state.user.type < 2
            ? '/samoevalvacija/programi'
            : '/samoevalvacija/vsi-programi'
      },
      { path: 'vsi-programi', name: 'evalvationProgramList', component: EvalvationProgramList },
      { path: 'podrobnosti/:q_type/:programs', name: 'programDetail', component: ProgramDetail },
      { path: 'vprasalnik', name: 'questionnaireBuild', component: QuestionnaireBuild },
      { path: 'programi', name: 'evalvationPrograms', component: EvalvationPrograms },
      { path: 'oddelki', name: 'evalvationDepartments', component: EvalvationDepartments },
      { path: 'oddelek/:department', name: 'departmentDetail', component: EvalvationDepartmentDetail },
      { path: 'oddelki-vprasalnik', name: 'departmentsQuestionnaire', component: EvalvationDepartmentQuestionnaireBuild },
      { path: 'samoevalvacija-analitika', name: 'evalvationAnalytics', component: EvalvationAnalytics },
      { path: 'sep-ai', name: 'evalvationAI', component: EvalvationAI },
      { path: 'faq', name: 'FAQEvalvation', component: FAQEvalvation },
      { path: 'dashboard', name: 'evalvationDashboard', component: EvalvationDashboard }
    ]
  },
  {
    path: '/uporabniki',
    component: Users,
    children: [
      { path: '', redirect: '/uporabniki/seznam-uporabnikov' },
      { path: 'seznam-uporabnikov', name: 'usersList', component: usersList },
      { path: 'obvescanje', name: 'informing', component: Informing }
    ]
  },
  { path: '/moj-racun', name: 'userProfile', component: userProfile },
  { path: '/login', name: 'login', component: Login },
  { path: '/login-password', name: 'login-password', component: LoginPassword },
  { path: '/faq', name: 'FAQGeneral', component: FAQGeneral },
  { path: '/obvestila', name: 'Notices', component: Notices },
  { path: '/nastavitev-gesla/:email/:hash', name: 'setPassword', component: SetPassword },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes
});

// Global auth guard for all routes
router.beforeEach((to, from, next) => {
  const publicPages = ['login', 'login-password', 'setPassword'];
  const isPublic = publicPages.includes(to.name);
  const isLoggedIn = !!store.state.user.id;

  if (!isLoggedIn && !isPublic
      && !hasMsalAuthResponseInUrl()
      && !isPendingSsoRedirectLogin()) {
    return next('/login');
  }

  next();
});

export default router;